import block from './block.json';

export const cardLogoThemeAttributes = {
	backgroundColor: '@tokens.variants.default.cardBackgroundColor',
	border: {
		color: '@tokens.variants.default.cardBorderColor',
		width: {
			top: [0, 0],
			right: [0, 0],
			bottom: [0, 0],
			left: [0, 0],
		},
		radius: {
			topLeft: [0, 0],
			topRight: [0, 0],
			bottomRight: [0, 0],
			bottomLeft: [0, 0],
		},
	},
	minWidth: '80px',
	maxWidth: '100px',
	padding: {
		top: [10, 10],
		right: [10, 10],
		bottom: [10, 10],
		left: [10, 10],
	},
	states: {
		hover: {}, // adds hover state
	},
};

export const CardLogoThemeControls: ThemeControlsType = {
	// What's displayed
	title: block.title,

	// Unique string/id of the block (= the key used in theme.json)
	slug: block.slug,

	// styling attributes available for this block
	// ...the same way we define attributes for a gutenberg block
	attributes: cardLogoThemeAttributes,

	// this renders in the Customizer panel
	// ...the same way "<InspectorControls />" renders in the gutenberg panel
	edit: () => null,
};
